import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoWalletTransactionLogListRequest,
  PerplayLogApi,
} from '../../models/src';
import { WALLET_TRANSACTIONLOG_LIST_REQUEST } from '../../constants/log/walletTransactionLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoWalletTransactionLogListResponse
  from '../../models/src/model/LogControllerDtoWalletTransactionLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* walletTransactionLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoWalletTransactionLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.transactionType = payload.transactionType;
    requestData.walletAddress = payload.walletAddress;
    requestData.targetWalletAddress = payload.targetWalletAddress;
    requestData.transactionNo = payload.transactionNo;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogWalletTransactionLogListPost({ logControllerDtoWalletTransactionLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoWalletTransactionLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* walletTransactionLogRootSaga() {
  yield all([
    takeEvery(WALLET_TRANSACTIONLOG_LIST_REQUEST, walletTransactionLogListRequestSaga),
  ])
}

const walletTransactionLogSagas = [
  fork(walletTransactionLogRootSaga),
];

export default walletTransactionLogSagas;
